export namespace Maintenance {

  export enum MaintenanceType {
    ReorganizeIndex = 0,
    RebuildIndex = 1,
    Cleanup = 2,
  }

  export enum MaintenanceStatus {
    Started = 0,
    Completed = 1,
    InProgress = 2,
    Error = 3,
    Warning = 4,
  }

  export class FragmentationProgress {
    type: MaintenanceType;
    status: MaintenanceStatus;
    progress: number;
    totalIndex: number;
    currentIndex: number;
    currentTable: string;
    currentIndexName: string;
    message: string;
    durationSeconds: number;
    fragmentationBefore: number;
    fragmentationAfter: number;
    improvement: number;
    timestamp: Date;

    constructor(data?: Partial<FragmentationProgress>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }

  export class CleanupProgress {
    type: MaintenanceType = MaintenanceType.Cleanup;
    status: MaintenanceStatus;
    message: string;
    cutoffUtc: string;
    batchSize: number;
    buckets: CleanupBucket[];
    currentTable?: CleanupTable;
    progress: number;
    databaseReclaim?: DatabaseSpaceReclaimProgress;
    timestamp: Date;
    totalDeleted: number;

    constructor(data?: Partial<CleanupProgress>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }

  export interface DatabaseSpaceReclaimProgress {
    requested: boolean;
    status: 'queued' | 'inProgress' | 'completed' | 'warning' | 'skipped';
    stage: string;
    message: string;
    progress: number;
    beforeAllocatedMb: number;
    afterAllocatedMb: number;
    reclaimedMb: number;
    beforeDataAllocatedMb: number;
    afterDataAllocatedMb: number;
    beforeLogAllocatedMb: number;
    afterLogAllocatedMb: number;
    recoveryModel?: string;
    logReuseWait?: string;
    files: DatabaseFileReclaimProgress[];
  }

  export interface DatabaseFileReclaimProgress {
    fileId: number;
    logicalName: string;
    fileType: string;
    beforeAllocatedMb: number;
    usedMb: number;
    targetMb: number;
    afterAllocatedMb: number;
    reclaimedMb: number;
    status: 'queued' | 'inProgress' | 'completed' | 'warning' | 'skipped';
    message?: string;
  }

  export interface CleanupCommandResult {
    accepted: boolean;
    isRunning: boolean;
    message: string;
  }

  export enum CleanupTable {
    AccessHistory = 0,
    TagPropertyHistory = 1,
    AutoHistory = 2,
    SimulatorData = 4,
    Tags = 5,
    TrackItems = 6,
    Readers = 7,
    ReaderAntennas = 8,
    GateDirections = 9,
    Gates = 10,
    Zones = 11,
    Floors = 12,
    Groups = 13,
    Buildings = 14
  }

  export class CleanupBucket {
    table: CleanupTable;
    deleted: number;
    totalRows?: number;
    progress: number = 0;
    notes?: string;
    operationKey?: string;
    parentTable?: CleanupTable;
    sortOrder?: number;
    isDetail?: boolean;

    constructor(data?: Partial<CleanupBucket>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }

  export class SqlServerMetrics {
    cpuUsagePercentage: number;
    cpuCount: number;
    totalPhysicalMemoryMB: number;
    availablePhysicalMemoryMB: number;
    sqlServerMemoryUsageMB: number;
    pendingQueries: number;
    activeConnections: number;
    timestamp: Date;

    constructor(data?: Partial<SqlServerMetrics>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }


  export class IndexInfo {
    tableName: string;
    indexName: string;
    recordCount: number;
    fragmentation: number;

    constructor(data?: Partial<IndexInfo>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }

  export class DatabaseHealthScore {
    healthScore: number;
    indexes: IndexInfo[];
    timestamp: Date;

    constructor(data?: Partial<DatabaseHealthScore>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }

  export class IndexFragmentationReport {
    index: number;
    tableName: string;
    indexName: string;
    recordCount: number;
    fragmentationBefore: number;
    fragmentationAfter: number;
    improvement: number;
    durationSeconds: number;
    operationType: string;
    timestamp: Date;

    constructor(data?: Partial<IndexFragmentationReport>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }


}
